import { jsx as n } from "react/jsx-runtime";
import { c as e, a as c } from "../../vendor-CwFtm_qv.js";
import { b as t } from "../../shared-button.module-BT8NBm4o.js";
import '../../assets/index3.css';const r = "ecwbsq_skipToContent", a = {
  skipToContent: r
}, f = ({ targetId: o = "main-content" }) => {
  const s = e({
    [t.baseButton]: !0,
    [t.secondary]: !0,
    [a.skipToContent]: !0
  });
  return /* @__PURE__ */ n(c, { href: `#${o}`, className: s, target: "_self", children: "Skip to main content" });
};
export {
  f as SkipToContent
};
//# sourceMappingURL=index.js.map
